import adminIcon from 'assets/icons/admin.svg';
import chevronUpIcon from 'assets/icons/chevron-up.svg';
import React, { useContext } from 'react';
import { Collapse, Link, LocaleContext } from 'shared';

import { SidebarMenuItem, SidebarSubmenu, SidebarSubmenuItem, SidebarWrapper } from './Sidebar.styles';
import { SidebarProps } from './Sidebar.types';

export const Sidebar = ({ location: { pathname } }: SidebarProps) => {
  const localeContext = useContext(LocaleContext);

  const apiMenuItemRenderer = (collapsed: boolean) => (
    <SidebarMenuItem className="sidebar__menu-item" active={true}>
      <img src={adminIcon} alt={localeContext.formatMessage({ id: 'SIDEBAR.ADMINISTRATOR' })} />
      {localeContext.formatMessage({ id: 'SIDEBAR.ADMINISTRATOR' })}
      <img
        src={chevronUpIcon}
        className={`collapse-icon ${collapsed ? 'collapse-icon--collapsed' : 'collapse-icon--not-collapsed'}`}
        alt={localeContext.formatMessage({ id: 'SIDEBAR.ADMINISTRATOR' })}
      />
    </SidebarMenuItem>
  );

  return (
    <SidebarWrapper className="sidebar">
      <Collapse collapsed={false} title={apiMenuItemRenderer}>
        <SidebarSubmenu className="sidebar__sub-menu">
          <SidebarSubmenuItem
            className="sub-menu__item"
            active={pathname.includes(`/endpoints`)}
            as={Link}
            {...{ url: `/endpoints` }}
          >
            {localeContext.formatMessage({ id: 'SIDEBAR.API-MANAGEMENT' })}
          </SidebarSubmenuItem>

          <SidebarSubmenuItem
            className="sub-menu__item"
            active={pathname.includes(`/tpps`)}
            as={Link}
            {...{ url: `/tpps` }}
          >
            {localeContext.formatMessage({ id: 'SIDEBAR.TPPS-MANAGEMENT' })}
          </SidebarSubmenuItem>

          <SidebarSubmenuItem
            className="sub-menu__item"
            active={pathname.includes(`/reports`)}
            as={Link}
            {...{ url: `/reports` }}
          >
            {localeContext.formatMessage({ id: 'SIDEBAR.REPORTS' })}
          </SidebarSubmenuItem>
        </SidebarSubmenu>
      </Collapse>
    </SidebarWrapper>
  );
};
